import React, { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

export const AbilityContext = createContext();

const ContextualCan = createContextualCan(AbilityContext.Consumer);

/**
 * Create Can component to validate user permission
 *
 * @casl/react v3+ returns children as-is; undefined children (e.g. `{flag && <X />}`
 * with flag undefined) make React 16 throw error #152, so render null instead.
 */
export const Can = ({ children, ...props }) => (
  <ContextualCan {...props}>
    {(allowed, ability) =>
      (typeof children === 'function' ? children(allowed, ability) : children) ??
      null
    }
  </ContextualCan>
);

export { ABILITY_ACTION, ABILITY_SUBJECT };
